import { useState, useEffect } from 'react';

/**
 * Utility functions for device detection
 */

/**
 * Detect if the current device is mobile based on screen width and user agent
 * @returns {boolean} true if mobile device
 */
export const isMobileDevice = () => {
  // Check screen width (consider mobile if width is less than 768px)
  const isMobileWidth = window.innerWidth < 768;
  
  // Check user agent for mobile patterns
  const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  return isMobileWidth || isMobileUserAgent;
};

/**
 * Hook to track mobile device state with window resize
 * @returns {boolean} true if mobile device
 */
export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return isMobile;
};